import { useState } from "react";
// import CommunityBarChart from "../MarketPlace/CommunityBarChart";
import CommunityAreaChart, { CommunityAreaChartTabs } from "../MarketPlace/CommunityAreaChart";
import { useSelector } from "react-redux";
import { isOlderThan7Days, simplifyTradingVolume } from "../../../helpers/helper";
import { useLocation } from "react-router-dom";
import { useDashboardMarket } from "../CommonComponents/DashboardMarketSelect/DashboardMarketContext";

function TradingGraph({ user, stats }) {
  // const [activeButton, setActiveButton] = useState("Week");
  const [activeTab, setActiveTab] = useState(2);
  const community = useSelector((state) => state?.user?.user?.leaderCommunity);
  const location = useLocation();
  const { selectedMarket, permissionType } = useDashboardMarket();
  const isMarketAllowed = permissionType === "both" || permissionType === selectedMarket;
  return (
    <div className={`TradingBox d-flex flex-column ${user?.role === "member" ? "mw-100" : ""} `}>
      <div className="topTradingBox ">
        <div className="contentSide">
          <p className="name">{location.pathname === "/member/dashboard" ? "PNL" : "PNL"}</p>
          <p className="numbers">{simplifyTradingVolume(stats?.pnl)}%</p>
          <p className="subTitle">
            <span>{simplifyTradingVolume(stats?.thisWeekPnlPercentage)}%</span> Since last week
          </p>
        </div>

        <div className="switchSide">
          {/* <div className="switchBase">
            <button className={`${activeButton === "Day" ? "active" : ""}`} onClick={() => setActiveButton("Day")}>Daily</button>
            <button className={`${activeButton === "Week" ? "active" : ""}`} onClick={() => setActiveButton("Week")}>Weekly</button>
            <button className={`${activeButton === "Month" ? "active" : ""}`} onClick={() => setActiveButton("Month")}>Monthly</button>
            <button className={`${activeButton === "All Time" ? "active" : ""}`} onClick={() => setActiveButton("All Time")}>All Time</button>
          </div> */}
          <CommunityAreaChartTabs activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
      </div>

      <div className="chartBox">
        {/* <CommunityBarChart duration={activeButton} graphType="pnl" userId={user?._id} /> */}
        {isMarketAllowed ? (
          <CommunityAreaChart
            bare
            graphType="pnl"
            userId={user?._id}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            market={selectedMarket}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 200 }}>
            <p style={{ color: "#9fa0a0", fontSize: 14 }}>No data available for this market</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TradingGraph;

